import { forwardRef, memo, useCallback } from 'react'
import { Controller } from 'react-hook-form'
import CustomTextField from '../textfield'

const ControlledTextField = forwardRef((props, ref) => {
  const { name, control, numericValue, ...rest } = props

  // Handlers
  const handleKeyDown = useCallback(
    (event) => {
      if (numericValue) {
        const { key, ctrlKey, metaKey, target } = event
        const cursorPosition = target.selectionStart

        if (
          (key === '-' &&
            cursorPosition === 0 &&
            !target.value.startsWith('-')) ||
          (key === '.' && !target.value.includes('.')) ||
          key === 'Backspace' ||
          key === 'Delete' ||
          (key >= '0' && key <= '9') ||
          ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(
            key
          ) ||
          ctrlKey ||
          metaKey
        ) {
          return
        }

        event.preventDefault()
      }
    },
    [numericValue]
  )

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange, onBlur } }) => (
        <CustomTextField
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          onKeyDown={(e) => handleKeyDown(e, value)}
          {...rest}
          onWheel={
            rest.type === 'number'
              ? (e) => {
                  e.target.blur()
                  rest?.onWheel && rest?.onWheel(e)
                }
              : rest?.onWheel
          }
        />
      )}
    />
  )
})

export default memo(ControlledTextField)
